export default __webpack_public_path__ + "static/media/slide12.6546e2c3.jpg";